import Link from 'next/link';
import Image from 'next/image';
import x from './logos/x.svg';
import facebook from './logos/facebook.svg';
import linkedIn from './logos/linkedIn.svg';
import discord from './logos/discord.svg';
import github from './logos/github.svg';

const socialLinks = [
  { name: 'X', logo: x, link: 'https://twitter.com/ClerkDev' },
  {
    name: 'Facebook',
    logo: facebook,
    link: 'https://www.facebook.com/clerkdev'
  },
  {
    name: 'LinkedIn',
    logo: linkedIn,
    link: 'https://www.linkedin.com/company/clerkinc/'
  },
  {
    name: 'Discord',
    logo: discord,
    link: 'https://discord.com/invite/b5rXHjAg7A'
  },
  { name: 'Github', logo: github, link: 'https://github.com/clerk' }
];

export function PricingFooter() {
  return (
    <footer className="mx-auto  px-6 py-16 md:px-8 lg:max-w-[76rem] xl:px-0">
      <div className="justify-between space-y-12 border-b border-b-newGray-600/10 pb-12 lg:flex lg:space-y-0">
        {/*eslint-disable-next-line @typescript-eslint/no-use-before-define*/}
        <Logo />
        <div className="grid grid-cols-2 gap-y-4 text-[0.8125rem] leading-6 sm:grid-cols-4 md:w-[50rem]">
          <div className="space-y-1 [&_a]:block">
            <h3 className="mb-3 font-semibold text-tertiary">Product</h3>
            <Link
              href="https://clerk.com/components"
              className="font-medium text-primary"
            >
              Components
            </Link>
            <Link
              href="https://clerk.com/pricing"
              className="font-medium text-primary"
            >
              Pricing
            </Link>
            <Link
              href="https://dashboard.clerk.com"
              className="font-medium text-primary"
            >
              Dashboard
            </Link>
            <Link
              href="https://feedback.clerk.com/roadmap"
              className="font-medium text-primary"
            >
              Feature requests
            </Link>
          </div>
          <div className="space-y-1 [&_a]:block">
            <h3 className="text-0.8125 mb-3 font-medium leading-6 text-tertiary">
              Developers
            </h3>
            <Link
              href="https://clerk.com/docs"
              className="font-medium text-primary"
            >
              Documentation
            </Link>
            <Link
              href="https://discord.com/invite/b5rXHjAg7A"
              className="font-medium text-primary"
            >
              Discord server
            </Link>
            <Link
              href="https://clerk.com/support"
              className="font-medium text-primary"
            >
              Support
            </Link>
            <Link
              href="https://clerk.com/changelog"
              className="font-medium text-primary"
            >
              Changelog
            </Link>
          </div>
          <div className="space-y-1 [&_a]:block">
            <h3 className="text-0.8125 mb-3 font-medium leading-6 text-tertiary">
              Company
            </h3>
            <Link
              href="https://clerk.com/company"
              className="font-medium text-primary"
            >
              About
            </Link>
            <Link
              href="https://jobs.ashbyhq.com/clerk"
              className="font-medium text-primary"
            >
              Careers
            </Link>
            <Link
              href="https://clerk.com/blog"
              className="font-medium text-primary"
            >
              Blog
            </Link>
            <Link
              href="https://drive.google.com/drive/folders/14FZPSKnI-AHadk8jn-TgaHPRqOyq0E10"
              className="font-medium text-primary"
            >
              Media kit
            </Link>
          </div>
          <div className="space-y-1 [&_a]:block">
            <h3 className="text-0.8125 mb-3 font-medium leading-6 text-tertiary">
              Legal
            </h3>
            <Link
              href="https://clerk.com/terms"
              className="font-medium text-primary"
            >
              Terms
            </Link>
            <Link
              href="https://clerk.com/privacy"
              className="font-medium text-primary"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
      <div className="justify-between space-y-4 pt-6 sm:flex sm:space-y-0">
        <div className="flex items-center gap-5 sm:order-2">
          {socialLinks.map(socialLink => (
            <Link href={socialLink.link} key={socialLink.name}>
              <Image src={socialLink.logo} alt={socialLink.name} unoptimized />
            </Link>
          ))}
        </div>
        <span className="inline-flex">© Clerk Inc.</span>
      </div>
    </footer>
  );
}

function Logo() {
  return (
    <svg
      width="62"
      height="18"
      viewBox="0 0 62 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="8.99998" cy="9" rx="2.81248" ry="2.8125" fill="#131316" />
      <path
        d="M14.0674 15.6601C14.3067 15.8994 14.2827 16.2955 14.0015 16.4838C12.571 17.4421 10.8504 18.0009 8.99928 18.0009C7.14816 18.0009 5.42758 17.4421 3.99704 16.4838C3.71589 16.2955 3.69186 15.8994 3.93114 15.6601L5.98648 13.6047C6.17224 13.419 6.46042 13.3896 6.69423 13.5094C7.38559 13.8636 8.1691 14.0634 8.99928 14.0634C9.82946 14.0634 10.613 13.8636 11.3043 13.5094C11.5381 13.3896 11.8263 13.419 12.0121 13.6047L14.0674 15.6601Z"
        fill="#131316"
      />
      <path
        opacity="0.4"
        d="M14.0022 1.51707C14.2833 1.70539 14.3073 2.10155 14.0681 2.34083L12.0127 4.39619C11.827 4.58195 11.5388 4.61129 11.305 4.49151C10.6136 4.13733 9.83011 3.9375 8.99993 3.9375C6.20401 3.9375 3.93747 6.20406 3.93747 9C3.93747 9.83019 4.1373 10.6137 4.49148 11.3051C4.61126 11.5389 4.58192 11.827 4.39616 12.0128L2.34082 14.0682C2.10154 14.3074 1.70537 14.2834 1.51705 14.0023C0.558854 12.5717 0 10.8511 0 9C0 4.02944 4.02941 0 8.99993 0C10.851 0 12.5716 0.558861 14.0022 1.51707Z"
        fill="#131316"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.478 11.9525C56.4866 11.9432 56.4987 11.938 56.5114 11.938C56.5271 11.938 56.5417 11.9461 56.55 11.9595L59.2172 16.2462C59.2428 16.2874 59.288 16.3125 59.3366 16.3125L61.7344 16.3125C61.8447 16.3125 61.912 16.1915 61.854 16.0978L58.1949 10.1939C58.1618 10.1406 58.1681 10.0719 58.2102 10.0254L61.7357 6.13572C61.8176 6.04534 61.7535 5.90066 61.6315 5.90066H59.13C59.0906 5.90066 59.053 5.91719 59.0263 5.94622L54.9474 10.3925C54.8607 10.487 54.7032 10.4257 54.7032 10.2974V1.82812C54.7032 1.75046 54.6402 1.6875 54.5625 1.6875H52.4532C52.3755 1.6875 52.3125 1.75046 52.3125 1.82812V16.1719C52.3125 16.2495 52.3755 16.3125 52.4532 16.3125L54.5625 16.3125C54.6402 16.3125 54.7032 16.2495 54.7032 16.1719V13.9147C54.7032 13.8792 54.7166 13.8449 54.7408 13.8189L56.478 11.9525ZM29.3905 1.82813C29.3905 1.75046 29.4535 1.6875 29.5312 1.6875H31.6405C31.7182 1.6875 31.7811 1.75046 31.7811 1.82813V16.1719C31.7811 16.2495 31.7182 16.3125 31.6405 16.3125H29.5312C29.4535 16.3125 29.3905 16.2495 29.3905 16.1719V1.82813ZM26.4137 13.2701C26.3576 13.2217 26.2739 13.2253 26.22 13.2761C25.8913 13.5864 25.5062 13.8347 25.0843 14.0078C24.6215 14.1979 24.1239 14.2936 23.622 14.2891C23.1982 14.3016 22.7762 14.2291 22.3821 14.076C21.988 13.9229 21.63 13.6925 21.3303 13.3989C20.7859 12.8431 20.4726 12.0496 20.4726 11.1037C20.4726 9.2101 21.7324 7.91491 23.622 7.91491C24.1288 7.90793 24.631 8.01058 25.0926 8.21543C25.511 8.40122 25.8868 8.66683 26.1981 8.99629C26.2514 9.05264 26.3398 9.05916 26.3984 9.00842L27.8225 7.7762C27.8806 7.72586 27.8877 7.63797 27.8364 7.58065C26.7653 6.38368 25.0872 5.76563 23.4914 5.76563C20.2783 5.76563 18 7.93299 18 11.1217C18 12.6988 18.5662 14.0268 19.5211 14.9645C20.4759 15.9023 21.8363 16.4531 23.4059 16.4531C25.374 16.4531 26.9581 15.6984 27.8869 14.7302C27.9414 14.6734 27.9354 14.583 27.8758 14.5315L26.4137 13.2701ZM43.4011 11.8056C43.3933 11.876 43.3334 11.9287 43.2625 11.9287H35.8732C35.7835 11.9287 35.7166 12.012 35.74 12.0986C36.1076 13.4614 37.2037 14.286 38.6997 14.286C39.204 14.2966 39.7038 14.1928 40.1607 13.9827C40.5864 13.787 40.964 13.5038 41.2683 13.1528C41.3051 13.1104 41.3693 13.1041 41.4124 13.1401L42.898 14.4335C42.9548 14.483 42.9627 14.5687 42.914 14.6262C42.0171 15.6843 40.5639 16.4531 38.5697 16.4531C35.5018 16.4531 33.1876 14.3286 33.1876 11.1009C33.1876 9.51732 33.7328 8.18944 34.6414 7.25179C35.1211 6.76962 35.6961 6.38911 36.3309 6.13368C36.9657 5.87826 37.6471 5.75332 38.3329 5.76658C41.4424 5.76658 43.4532 7.95343 43.4532 10.973C43.4493 11.2512 43.4319 11.5291 43.4011 11.8056ZM35.7844 9.84589C35.7583 9.93268 35.8253 10.0172 35.916 10.0172H40.8292C40.92 10.0172 40.9871 9.93217 40.9619 9.84491C40.627 8.68592 39.7774 7.91244 38.4579 7.91244C38.0698 7.90013 37.6836 7.97039 37.3256 8.11831C36.9677 8.26633 36.6464 8.48856 36.3838 8.76977C36.1077 9.08283 35.9036 9.44988 35.7844 9.84589ZM50.7641 5.76717C50.8424 5.76632 50.9063 5.82952 50.9063 5.90779V8.26951C50.9063 8.35135 50.8367 8.41586 50.755 8.40981C50.5271 8.39291 50.3116 8.37855 50.1703 8.37855C48.3303 8.37855 47.2501 9.67358 47.2501 11.3735V16.1719C47.2501 16.2495 47.1871 16.3125 47.1094 16.3125H45.0001C44.9224 16.3125 44.8595 16.2495 44.8595 16.1719V6.05379C44.8595 5.97613 44.9224 5.91317 45.0001 5.91317H47.1094C47.1871 5.91317 47.2501 5.97613 47.2501 6.05379V7.47394C47.2501 7.48196 47.2566 7.48845 47.2646 7.48845C47.2691 7.48845 47.2735 7.48627 47.2762 7.4826C48.1008 6.38146 49.3178 5.76891 50.6035 5.76891L50.7641 5.76717Z"
        fill="#131316"
      />
    </svg>
  );
}
